import React, { useState } from 'react';

const ImportModalContent = ({ onClose, onSubmit, setImportFileLoading, importFileLoading }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = () => {
    setImportFileLoading(true);
    if (!selectedFile) {
      setImportFileLoading(false);
      alert('Please select a file first.');
      return;
    }
    onSubmit(selectedFile);
  };

  return (
    <div className="p-3">
      <h5 className="mb-3">Import Manufacturing Data</h5>
      <input
        type="file"
        accept=".xlsx"
        onChange={handleFileChange}
        className="form-control mb-3"
      />
      <div className="d-flex justify-content-end gap-2">
        <button onClick={onClose} className="btn btn-secondary">
          Close
        </button>
        <button onClick={handleSubmit} className={`btn btn-primary ${importFileLoading ? 'disabled' : ''}`} disabled={importFileLoading}>
          {importFileLoading && (
            <span
              className="spinner-border spinner-border-sm text-white me-2"
              role="status"
            />
          )}
          {importFileLoading ? 'Submiting...' : 'Submit'}
        </button>
      </div>
    </div>
  );
};

export default ImportModalContent;
